export const COMPANY = {
  name: "Hélios Solutions",
  full: "Hélios Solutions – Énergie & Habitat",
  phone: "06 10 70 26 20",
  phoneHref: "tel:+33610702620",
  phoneDigits: "0610702620",
  email: "helios.solutions.contact@gmail.com",
  zone: "Île-de-France + France entière",
  tagline: "Réduisez vos factures de chauffage dès maintenant",
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/d8ead892-d437-410a-9c42-fd6e29a616eb/images/738c0ade6edd9b203a60354312dd9d1f479c6d9dd41697ff48b4ef5257055cbc.png",
  renovation: "https://images.pexels.com/photos/6124239/pexels-photo-6124239.jpeg",
  family: "https://images.pexels.com/photos/7642220/pexels-photo-7642220.jpeg",
  technician: "https://images.pexels.com/photos/8293778/pexels-photo-8293778.jpeg",
  house: "https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg",
  heatpump: "https://images.unsplash.com/photo-1687904574925-4bc8464c0624?auto=format&fit=crop&w=1200&q=80",
};

export const TESTIMONIALS = [
  {
    name: "Sophie M.",
    location: "Melun (77)",
    heating: "Ancien chauffage fioul",
    quote:
      "Nous avons été accompagnés du premier appel à la mise en service. L'équipe a pris le temps d'étudier notre maison avant de proposer une pompe à chaleur air/eau vraiment adaptée. Depuis, nos factures ont nettement baissé.",
    rating: 5,
  },
  {
    name: "Jean-Marc & Isabelle",
    location: "Rambouillet (78)",
    heating: "Rénovation complète",
    quote:
      "Très bon suivi, rien n'a été laissé au hasard. On nous a clairement expliqué le reste à charge selon notre situation, sans fausses promesses. Le chantier a été propre et rapide.",
    rating: 5,
  },
  {
    name: "Karim B.",
    location: "Chartres (28)",
    heating: "Remplacement chaudière gaz",
    quote:
      "Ce que j'ai apprécié : des conseils honnêtes et des artisans qualifiés. L'étude personnalisée m'a évité de choisir une solution surdimensionnée. Résultat : confort amélioré et consommation baissée.",
    rating: 5,
  },
];

export const FAQ_ITEMS = [
  {
    q: "Quels types de travaux proposez-vous ?",
    a: "Nous accompagnons sur l'installation de pompes à chaleur air/eau, le remplacement de chaudières fioul ou gaz, et les projets de rénovation énergétique (isolation, régulation, ballon thermodynamique).",
  },
  {
    q: "L'étude d'éligibilité m'engage-t-elle ?",
    a: "Non. L'étude personnalisée est sans engagement. Elle vise à identifier les solutions adaptées à votre logement et à votre situation avant toute décision.",
  },
  {
    q: "Existe-t-il des aides pour ces travaux ?",
    a: "Des aides peuvent exister selon votre situation, votre logement et votre localisation. Le reste à charge est variable selon profil. Nous vous présentons les dispositifs potentiellement mobilisables de manière claire et transparente.",
  },
  {
    q: "Qui réalise l'installation ?",
    a: "Les installations sont confiées à des professionnels qualifiés, sélectionnés pour leur sérieux et leur savoir-faire, afin d'assurer un chantier propre, conforme et durable.",
  },
  {
    q: "Dans quelle zone intervenez-vous ?",
    a: "Nous intervenons principalement en Île-de-France et étendons nos solutions sur l'ensemble de la France métropolitaine selon les projets.",
  },
  {
    q: "Combien de temps prend une installation de pompe à chaleur ?",
    a: "La durée varie selon la configuration du logement. En général, l'installation d'une pompe à chaleur air/eau prend 2 à 4 jours. Le délai précis est confirmé lors de l'étude personnalisée.",
  },
];

export const ADVANTAGES = [
  {
    icon: "MagnifyingGlass",
    title: "Étude personnalisée",
    desc: "Analyse complète de votre logement et de vos besoins, sans engagement.",
  },
  {
    icon: "HeadCircuit",
    title: "Accompagnement complet",
    desc: "Un interlocuteur dédié du premier échange à la mise en service.",
  },
  {
    icon: "Wrench",
    title: "Professionnels qualifiés",
    desc: "Des artisans sélectionnés pour la qualité et le sérieux de leur travail.",
  },
  {
    icon: "Leaf",
    title: "Solutions adaptées",
    desc: "Des équipements dimensionnés selon votre situation, pas des offres standards.",
  },
];

export const STEPS = [
  {
    number: "01",
    title: "Analyse de votre situation",
    desc: "Nous échangeons avec vous pour comprendre votre logement, votre chauffage actuel et vos objectifs.",
  },
  {
    number: "02",
    title: "Étude d'éligibilité",
    desc: "Nous identifions les solutions techniques adaptées et les aides potentiellement mobilisables selon votre profil.",
  },
  {
    number: "03",
    title: "Proposition adaptée",
    desc: "Vous recevez une proposition claire, sans engagement, avec un reste à charge estimé.",
  },
  {
    number: "04",
    title: "Installation par un professionnel",
    desc: "Un artisan qualifié réalise l'installation dans les règles de l'art avec un suivi complet.",
  },
];
